import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';
import TeaserImages from '../Helpers/TeaserImages';
import RelatedItemsDisplay from '../Helpers/RelatedItemsDisplay';
import Sections from '../Helpers/Sections';
import DefaultViewWithoutTitle from '../../Custom/DefaultViewWithoutTitle';
import { hasImage, vocabTitle } from '../../../helpers/content';
import { flattenRichTextToAppURL } from '../../../helpers/richText';

const RobotView = (props) => {
  const { content } = props;
  const teaserImage1 = content.teaser_image1;
  const teaserImage2 = content.teaser_image2;
  const hasImages = hasImage(teaserImage1) || hasImage(teaserImage2);

  const yearLabel = vocabTitle(content.robot_year);
  const isActive = content.is_active !== false;

  const hasInfo = yearLabel || content.is_active != null;

  const hasDetails =
    content.robot_details?.data && content.robot_details.data !== '<p></p>';

  const hasCompetitions =
    content.related_competitions?.length > 0 &&
    !content.hide_related_competitions;
  const hasTopics =
    content.related_topics?.length > 0 && !content.hide_related_topics;

  return (
    <Container id="view-wrapper" className="RobotView">
      {/* Header */}
      <div className="view-header">
        <div className="view-header__badges">
          {!isActive && <span className="view-header__subtitle">Retired</span>}
        </div>
        <h2 className="view-header__title">{content.title || content.id}</h2>
        {/* No description here. `description` is a listing field - the one
            line that goes on a card and into a search result - and repeating
            it as the first paragraph of the page it summarises says the same
            thing twice. The full view has its own content. */}
        <div className="view-header__divider" />
      </div>
      <Sections>
        {/* Teaser Images */}
        {hasImages && <TeaserImages content={content} />}

        {/* Info */}
        {hasInfo && (
          <>
            <div className="view-meta-grid">
              <div className="view-meta-grid__col">
                {yearLabel && (
                  <div className="view-section">
                    <h3 className="view-section__label">Year Introduced:</h3>
                    <p className="view-section__value">{yearLabel}</p>
                  </div>
                )}
              </div>
              <div className="view-meta-grid__col">
                {content.is_active != null && (
                  <div className="view-section">
                    <h3 className="view-section__label">Status:</h3>
                    <p className="view-section__value">
                      {isActive ? 'Active' : 'Retired'}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </>
        )}

        {/* Details */}
        {hasDetails && (
          <>
            <div className="view-section">
              <h3 className="view-section__label">Details:</h3>
              <div
                className="view-section__richtext"
                dangerouslySetInnerHTML={{
                  __html: flattenRichTextToAppURL(content.robot_details.data),
                }}
              />
            </div>
          </>
        )}

        {/* Related Competitions */}
        {hasCompetitions && (
          <>
            <div className="view-section">
              <h3 className="view-section__label">Related Competitions:</h3>
              <RelatedItemsDisplay
                items={content.related_competitions}
                mode={content.related_competitions_display}
                kind="plain"
                fieldKey={`${content['@id']}-related_competitions`}
              />
            </div>
          </>
        )}

        {/* Related Topics */}
        {hasTopics && (
          <>
            <div className="view-section">
              <h3 className="view-section__label">Related Topics:</h3>
              <RelatedItemsDisplay
                items={content.related_topics}
                mode={content.related_topics_display}
                kind="plain"
                fieldKey={`${content['@id']}-related_topics`}
              />
            </div>
          </>
        )}
      </Sections>

      {/* The block-rendered part of the page */}
      <DefaultViewWithoutTitle {...props} />
    </Container>
  );
};

RobotView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.string,
    description: PropTypes.string,
    robot_year: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ title: PropTypes.string }),
    ]),
    is_active: PropTypes.bool,
    robot_details: PropTypes.shape({ data: PropTypes.string }),
    teaser_image1: PropTypes.object,
    teaser_image1_caption: PropTypes.string,
    teaser_image1_copyright: PropTypes.string,
    teaser_image1_copyright_black_font: PropTypes.bool,
    teaser_image2: PropTypes.object,
    teaser_image2_caption: PropTypes.string,
    teaser_image2_copyright: PropTypes.string,
    teaser_image2_copyright_black_font: PropTypes.bool,
    items: PropTypes.arrayOf(PropTypes.object),
    hide_related_competitions: PropTypes.bool,
    hide_related_topics: PropTypes.bool,
    related_competitions_display: PropTypes.string,
    related_topics_display: PropTypes.string,
    related_competitions: PropTypes.arrayOf(
      PropTypes.shape({ '@id': PropTypes.string, title: PropTypes.string }),
    ),
    related_topics: PropTypes.arrayOf(
      PropTypes.shape({ '@id': PropTypes.string, title: PropTypes.string }),
    ),
  }).isRequired,
};

export default RobotView;
